// src/firebaseConfig.js

// --- Firebase SDK Imports ---
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
// import { getStorage, connectStorageEmulator } from 'firebase/storage'; // Uncomment if you use Storage

// --- YOUR ACTUAL FIREBASE PROJECT CONFIGURATION ---
// !!! IMPORTANT: These are your project's live credentials. Do NOT change them.
export const firebaseConfig = {
  apiKey: "AIzaSyBVOX0lBOgggDanOuqTzEL3B0FY7_LyjPE",
  authDomain: "guided-botswana.firebaseapp.com",
  projectId: "guided-botswana",
  storageBucket: "guided-botswana.firebasestorage.app",
  messagingSenderId: "488260239279",
  appId: "1:488260239279:web:3abc1e2550961d356e795a",
  measurementId: "G-VZQ51L82K5"
};

// --- Initialize the Firebase App ---
const app = initializeApp(firebaseConfig);

// --- Get Instances of Firebase Services ---
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
// const storage = getStorage(app); // Uncomment if you use Storage

// --- Connect to Firebase Emulators (opt-in) ---
// Previously, any localhost/LAN dev URL auto-connected to emulators. If the Auth
// emulator is not running (nothing listening on :9099), sign-in/sign-up fails with
// auth/network-request-failed. Set REACT_APP_USE_FIREBASE_EMULATORS=true in .env.local
// and run `firebase emulators:start` when you want the local stack.
const hostname = window.location.hostname;
const isLocalHost =
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname === '[::1]' ||
  /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
  /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
  /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname);

const useFirebaseEmulators =
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';

if (isLocalHost && useFirebaseEmulators) {
  const emulatorHost =
    hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]'
      ? 'localhost'
      : hostname;

  console.log('[Firebase] Using local emulators at', emulatorHost);

  connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(db, emulatorHost, 8080);
  connectFunctionsEmulator(functions, emulatorHost, 5001);
  // connectStorageEmulator(storage, emulatorHost, 9199);
} else if (isLocalHost) {
  console.log(
    '[Firebase] Production project (no emulators). Set REACT_APP_USE_FIREBASE_EMULATORS=true in .env.local to use local emulators.',
  );
}

// --- Export the Initialized Services ---
export { app, auth, db, functions };
// export { app, auth, db, functions, storage }; // Uncomment if you export storage
